<template>
  <v-container fluid class="px-0 pt-0">
    <Loading v-if="isLoading"/>
    <v-row class="px-8 py-4 topBar">
      <v-col cols="3" class="pr-4 pl-3">

      </v-col>

      <v-spacer></v-spacer>
      <v-radio-group v-model="optionShowList" row style="margin:0" class="radioType">
        <v-radio label="Campaign" value="campaign" style="margin-right: 100px;" @change="() => changeType('campaign')"></v-radio>
        <v-radio label="Un-register" value="identity" @change="() => changeType('identity')"></v-radio>
      </v-radio-group>
      <v-col cols="2" class="text-right">
        <div class="d-flex align-center justify-end">
          <span class="pr-2">Recherche par :</span>
          <v-select
          v-model="searchBy"
          :items="listSearch"
          hide-details
          outlined
          max-width="100"
          style="max-width: 100px"
        ></v-select>
        </div>
      </v-col>

      <v-col cols="2">
        <v-text-field hide-details outlined dense v-model="searchText" @keyup.enter="() => search()">
          <template v-slot:append>
            <v-btn depressed color="primary" class="topBar-search ma-0"
            @click="search"
            >
              <v-icon v-text="'$search'"></v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-simple-table class="table-full table-fixed-height" :fixed-header= "true" v-if="optionShowList == 'campaign'">
      <thead>
        <tr>
          <th rowspan="2">ID</th>
          <th rowspan="2">Campaign ID</th>
          <th rowspan="2" style="min-width: 300px">Client</th>
          <th rowspan="2">Date time sent</th>
          <th colspan="3" class="border-col">Push app</th>

          <th colspan="6" class="border-col">Push Browser</th>
          <th rowspan="2">Message</th>
          <th rowspan="2">Sent by</th>
        </tr>
        <tr>
          <th>Sent</th>
          <th>Delivery</th>
          <th style="border-right: thin solid rgba(0, 0, 0, 0.12);">Click on</th>

          <th>Source</th>
          <th>Device</th>
          <th>Browser</th>
          <th>Sent</th>
          <th>Delivery</th>
          <th>Click on</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.id }}</td>
          <td>{{ item.invoice ? item.invoice.invoiceNumber : ''}}</td>
          <td>{{ item.client.name }}</td>
          <td>{{ item.sentAt | moment('DD/MM/YYYY') }}</td>
          <td>{{ item.mobileSent }}</td>
          <td>{{ item.mobileDelivery }}</td>
          <td>{{ item.mobileClick }}</td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="100" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/source.png" width="18" style="margin: auto" />
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Source</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticSource" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="50" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/laptop.png" width="18" style="margin: auto" />
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Device</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticDevice" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="50" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/earth_icon.png" width="18" style="margin: auto" />
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Browser</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticBrowser" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>{{ item.browserSent }}</td>
          <td>{{ item.browserDelivery }}</td>
          <td>{{ item.browserClick }}</td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" offset-y :nudge-left="100" v-if="item.payload.title">
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/document.png" width="18" style="margin: auto" />
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pa-4">
                <v-row style="width: 300px">
                  <v-col :cols="item.payload.icon ? 9 : 12">
                    <p class="font-weight-black">{{item.payload.title}}</p>
                    <p class="mb-0">{{item.payload.body}}</p>
                  </v-col>
                  <v-col cols="3" v-if="item.payload.icon">
                    <v-img :src="item.payload.icon" width="80px"/>
                  </v-col>
                </v-row>
                <v-row style="width: 300px" v-if="item.payload.link">
                  <v-col>
                    <p class="font-weight-black mb-1">URL:</p>
                    <a :href="item.payload.link" target="_blank">{{item.payload.link}}</a>
                  </v-col>
                </v-row>
                <v-row style="width: 300px" v-if="item.payload.notificationName">
                  <v-col>
                    <p class="font-weight-black mb-1">Contenu:</p>
                    <p>{{item.payload.notificationName}}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>
          </td>
          <td>{{ item.sentBy ? item.sentBy.firstName : '' }}</td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-simple-table class="table-full table-fixed-height" :fixed-header= "true" v-if="optionShowList == 'identity'">
      <thead>
        <tr>
          <th rowspan="2">ID</th>
          <th rowspan="2">Date time sent</th>
          <th colspan="6" class="border-col">Push Browser</th>

          <th rowspan="2">Message</th>
          <th rowspan="2">Sent by</th>
        </tr>
        <tr>
          <th>Source</th>
          <th>Device</th>
          <th>Browser</th>
          <th>Sent</th>
          <th>Delivery</th>
          <th>Click on</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.id }}</td>
          <td>{{ item.sentAt | moment('DD/MM/YYYY')}}</td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="100" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/source.png" width="18" style="margin: auto"/>
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Source</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticSource" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="50" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/laptop.png" width="18" style="margin: auto"/>
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Device</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticDevice" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" :nudge-left="50" offset-y>
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/earth_icon.png" width="18" style="margin: auto"/>
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pt-4">
                <v-simple-table :fixed-header= "true">
                  <thead>
                    <tr>
                      <th class="paddingLeft">Browser</th>
                      <th class="paddingLeft">Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in item.statisticBrowser" :key="index">
                      <td class="paddingLeft">{{ item.name }}</td>
                      <td class="paddingLeft">{{ item.total }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-menu>
          </td>
          <td>{{ item.browserSent }}</td>
          <td>{{ item.browserDelivery }}</td>
          <td>{{ item.browserClick }}</td>
          <td>
            <v-menu :close-on-content-click="false" :nudge-width="100" offset-y :nudge-left="100" v-if="item.payload.title">
              <template v-slot:activator="{ on }">
                <span class="headline btn-quest" v-on="on">
                  <v-img src="../../assets/document.png" width="18" style="margin: auto"/>
                </span>
              </template>
              <v-card flat class="popup-confirm-small elevation-3 pa-4">
                <v-row style="width: 300px">
                  <v-col :cols="item.payload.icon ? 9 : 12">
                    <p class="font-weight-black">{{item.payload.title}}</p>
                    <p class="mb-0">{{item.payload.body}}</p>
                  </v-col>
                  <v-col cols="3" v-if="item.payload.icon">
                    <v-img :src="item.payload.icon" width="80px"/>
                  </v-col>
                </v-row>
                <v-row style="width: 300px" v-if="item.payload.link">
                  <v-col>
                    <p class="font-weight-black mb-1">URL:</p>
                    <a :href="item.payload.link" target="_blank">{{item.payload.link}}</a>
                  </v-col>
                </v-row>
                <v-row style="width: 300px" v-if="item.payload.notificationName">
                  <v-col>
                    <p class="font-weight-black mb-1">Contenu:</p>
                    <p>{{item.payload.notificationName}}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>
          </td>
          <td>{{ item.sentBy ? item.sentBy.firstName : '' }}</td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="mt-4 mb-1 mx-4" v-if="totalItems > 0">
      <div class="d-flex align-center">
        <span class="mr-4">Affichage</span>
        <v-select
          v-model="limit"
          :items="itemPerPageList"
          hide-details
          dense
          outlined
          style="max-width: 90px"
        ></v-select>
        <span class="ml-4 mr-2">sur {{ totalItems }} items par page</span>
        <v-pagination class="justify-start" v-model="page" :length="totalPage"></v-pagination>
      </div>
    </div>

  </v-container>
</template>

<script>

import { mapState } from 'vuex';
import NotificationsService from '../../services/notifications.service';
import Loading from '../../components/Loading.vue';

export default {
  name: "Clients",
  data: () => ({
    dialogAddClient: false,
    editId: 0,
    isLoading: false,
    page: 1,
    totalPage: 1,
    items: [],
    limit: 50,
    totalItems: 0,
    searchText: '',
    searchBy: '',
    listSearch:[],
    optionShowList: 'campaign',
  }),
  components: {
    Loading
  },
  computed: {
   ...mapState({
      itemPerPageList: state => state.pagination.itemPerPageList,
      itemPerPage: state => state.pagination.itemPerPage
    }),
  },
  created() {
    this.listSearch = [
      {
        text: 'Client',
        value: 'c.name'
      },
      {
        text: 'Sent By',
        value: 'a.firstName'
      },
      {
        text: 'Campaign Id',
        value: 'i.invoiceNumber'
      }
    ];

    this.fetch();
  },
  methods: {
    async fetch(cb = null) {
      this.isLoading = true;
      try {
        const response = await NotificationsService.getPagedResult(
          {
            page: this.page,
            limit: this.limit,
            searchText: this.searchText,
            searchBy: this.searchBy,
            type: this.optionShowList
          }
        );

        this.items = response.data.data;
        this.totalItems = response.data.total;
        this.totalPage = response.data.totalPage;
        if (typeof (cb) === 'function') {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },
    search(){
      this.fetch();
    },
    changeType(value) {
      this.optionShowList = value;
      this.searchText = '',
      this.searchBy = '',
      this.fetch();
    },
    onClientAdded(id) {
      this.fetch();
    },
    edit(id) {
      this.editId = id;
      this.dialogAddClient = true;
    },
    add() {
      this.editId = 0;
      this.dialogAddClient = true;
    }
  },
  watch:{
    page(item){
        this.page = item;
        this.fetch();
    },
    limit(item){
        this.fetch();
    }
  }
};
</script>

<style>
.v-application--is-ltr .v-messages{
  display: none
}
.title-eduversal {
    color: #7D7D7D;
    position: absolute;
    top: 35px;
    left: 55px;
}
.v-data-table thead tr th.paddingLeft {
  padding-left: 16px !important;
  background-color: #F2F2F2 !important;
  font-size: 14px;
}
.v-data-table td.paddingLeft{
  padding-left: 16px !important;
  text-align: center;
  font-size: 13px;
}
.radioType.v-input--radio-group.v-input--radio-group--row .v-radio .v-label.v-label{
  color: #000
}
</style>
